import styled, { css } from 'styled-components';
import { StyledModal } from '../Modals-styled';


export const SummaryModal = styled(StyledModal)<{mobile:boolean, lowHeight:boolean}>`
	.ant-modal-body .anticon {
		color: unset;
	}

	@media print {
		& .anticon {
			visibility: hidden;
		}
	}

	max-width: calc(100% - 16px);

	padding-bottom: 100px;

	${(props) => props.lowHeight && css`
		top: 8px;
		padding-bottom: 8px;
	`}

	${(props) => props.mobile && css`
		top: 0px;
		padding-bottom: 0px;
	`}
`;

export const SummaryModalLogoContainer = styled.div`
	width: 100%;
	text-align: center;
	height: 90px;
	overflow: visible;
	position: relative;
	user-select: none;
`;

export const SummaryModalRingScreenshot = styled.img`
	max-width: 100%;
`;

export const SummaryTable = styled.table`
	width: 100%;
	border-collapse: none;
`;

export const SummaryTableHeader = styled.tr`
	font-size: 1.1rem;
	font-weight: 600;
	border-bottom: 2px solid ${(props) => props.theme.colors.darkGray};

	& > td {
		padding-top: 20px;
	};
	
	/* &:nth-of-type(2) > td {
		padding-top: 5px;
	}; */
`;

export const SummaryTableTitle = styled(SummaryTableHeader)`
	font-size: 1.4rem;
	font-weight: 600;
	border-bottom: 2px solid ${(props) => props.theme.colors.fallow};
	text-align: center;

	& > td {
		padding-top: 10px;
		padding-bottom: 5px;
	};
`;

export const SummaryTableRow = styled.tr`
	& > td {
		padding-top: 6px;
	};

	& ~ & > td {
		padding-top: 3px;
	};

	& > td:first-child {
		font-weight: 600;
	};
`;

export const SummaryTablePriceRow = styled.tr`
	font-size: 1.1rem;
	font-weight: 600;

	& > td {
		padding-top: 20px;
	};
`;

export const SummaryTableReferenceNumberRow = styled.tr`
	font-size: 0.9rem;	
`;

export const SummaryTablePrintRow = styled.tr`
	text-align: right;
	vertical-align: bottom;

	& span {
		cursor: pointer;
	}

	& span:hover {
		color: ${(props) => props.theme.colors.fallow};
		text-decoration: underline;
	}

	& .anticon {
		padding-left: 6px;
	}

	@media print {
		display: none;
	}
`;